import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';

import { ArquivoExtensaoPipe } from './arquivo-extensao.pipe';
import { ArquivoExtensaoIconPipe } from './arquivo-extensao-icon.pipe';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        ArquivoExtensaoPipe,
        ArquivoExtensaoIconPipe
    ],
    exports: [
        ArquivoExtensaoPipe,
        ArquivoExtensaoIconPipe
    ],
    providers: [
        ArquivoExtensaoPipe,
        ArquivoExtensaoIconPipe
    ]
})
export class ArquivoExtensaoPipeModule { }
